module.exports = __webpack_public_path__ + "static/img/4.620aa77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-es/4.jpg
// module id = KqcB
// module chunks = 1